import * as yup from 'yup'
import { hasDecoderLink } from '@/utils/decoderLink'

export enum EValveType {
  Pump = 0,
  'Normally open' = 1,
  'Normally closed' = 2,
  'Booster pump' = 3,
}

export const typeList = [
  { value: 0, label: 'Pump' },
  { value: 1, label: 'Normally open' },
  { value: 2, label: 'Normally closed' },
  { value: 3, label: 'Booster pump' },
]

export const schema = yup.object({
  type: yup.string().trim().required('Type is required'),
  // addressValve: yup.string().trim().required('IO is required'),
  address: yup
    .object()
    .required('IO is required')
    .test('has-decoder', 'IO is required', (value) => hasDecoderLink(value as any)),
  priority: yup
    .number()
    .typeError('Priority must be a number')
    .min(0, 'Priority cannot be negative')
    .max(255, 'Priority cannot be more than 255'),
  startDelay: yup
    .number()
    .typeError('Start Delay  must be a number')
    .max(255, 'Start Delay must be less than 256')
    .min(0, 'Start Delay cannot be negative'),
  stopDelay: yup
    .number()
    .typeError('Stop Delay must be a number')
    .max(255, 'Stop Delay must be less than 256')
    .min(0, 'Stop Delay cannot be negative'),
  capacity: yup
    .number()
    .typeError('Capacity must be a number')
    .min(0, 'Capacity cannot be negative'),
})
